import { render, staticRenderFns } from "./table-list.vue?vue&type=template&id=1bb039df&scoped=true&"
import script from "./table-list.vue?vue&type=script&lang=js&"
export * from "./table-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb039df",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bb039df')) {
      api.createRecord('1bb039df', component.options)
    } else {
      api.reload('1bb039df', component.options)
    }
    module.hot.accept("./table-list.vue?vue&type=template&id=1bb039df&scoped=true&", function () {
      api.rerender('1bb039df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/statistic/export-center/modules/table-list.vue"
export default component.exports